"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTagPersonsProperty = exports.tagPersonsPropertyDefinition = void 0;
exports.tagPersonsPropertyDefinition = {
    view: {
        label: 'Athletes & Artists',
        style: '',
        hint: 'Related to an athlete or artist? Tag it and the asset shows on the athlete/artist page.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['artist', 'athlete'],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'tag-persons',
};
const isTagPersonsProperty = (prop) => {
    return prop.name === exports.tagPersonsPropertyDefinition.name;
};
exports.isTagPersonsProperty = isTagPersonsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFnLXBlcnNvbnMucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy90YWctcGVyc29ucy5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDRCQUE0QixHQUFHO0lBQzFDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxvQkFBb0I7UUFDM0IsS0FBSyxFQUFFLEVBQUU7UUFDVCxJQUFJLEVBQUUseUZBQXlGO0tBQ2hHO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsQ0FBQyxRQUFRLEVBQUUsU0FBUyxDQUFDO1NBQ2hDO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLGFBQWE7Q0FDWSxDQUFBO0FBSTFCLE1BQU0sb0JBQW9CLEdBQUcsQ0FBQyxJQUFrQixFQUE4QixFQUFFO0lBQ3JGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxvQ0FBNEIsQ0FBQyxJQUFJLENBQUE7QUFDeEQsQ0FBQyxDQUFBO0FBRlksUUFBQSxvQkFBb0Isd0JBRWhDIn0=